var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-container o-container--thin onboarding-page"},[_c('subscriptions-form',{attrs:{"contactId":this.data.contactId}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }